import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const OurSpace = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[70vh] min-h-[500px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(/images/DIK_4010-2.jpg)',
            filter: 'brightness(0.6)'
          }}
        />
        <div className="relative z-10 text-center text-white px-4" data-aos="fade-up">
          <h1 className="text-4xl md:text-7xl font-bold mb-6">Our Space</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            A quiet setting where thoughtful design meets warm hospitality
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div className="text-black space-y-6" data-aos="fade-right">
              <h2 className="text-xl md:text-3xl font-bold mb-6" style={{ color: '#31415A' }}>
                Designed to Be Calm and Comfortable
              </h2>
              <p className="text-xl leading-relaxed text-gray-700">
                Our space is intentionally small–designed to be calm and comfortable. A quiet
                setting where thoughtful design meets warm hospitality, creating an environment
                that invites you to slow down, focus, work from a cafe and enjoy coffee at your own
                space.
              </p>
            </div>
            <div className="relative" data-aos="fade-left">
              <img
                src="/images/DIK_4008-2.jpg"
                alt="Iraga Interior"
                className="rounded-lg shadow-2xl w-full h-[500px] object-cover"
              />
            </div>
          </div>

          {/* Gallery Grid */}
          <div className="grid md:grid-cols-3 gap-8" data-aos="fade-up" data-aos-delay="200">
            <div className="relative h-[400px] overflow-hidden rounded-lg shadow-lg">
              <img
                src="/images/DIK_4134-2.jpg"
                alt="Interior 1"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="relative h-[400px] overflow-hidden rounded-lg shadow-lg">
              <img
                src="/images/DIK_4008-2.jpg"
                alt="Interior 2"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="relative h-[400px] overflow-hidden rounded-lg shadow-lg">
              <img
                src="/images/DIK_4010-2.jpg"
                alt="Interior 3"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center mt-20" data-aos="fade-up">
            <h3 className="text-2xl md:text-4xl font-bold mb-6" style={{ color: '#31415A' }}>
              Visit Us Today
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Experience the perfect blend of comfort and quality. Whether you're here to work,
              relax, or connect, our space is designed with you in mind.
            </p>
            <a
              href="/our-location"
              className="inline-block px-8 py-4 bg-[#C9A14F] text-white font-bold rounded-lg hover:bg-[#B8903F] transition-colors duration-300"
            >
              Find Our Location
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurSpace;
